import React, { useState } from 'react';
import logo from '../assets/new-logo.jpg';

export default function Header() {
  const [menuAberto, setMenuAberto] = useState(false);

  const toggleMenu = () => {
    setMenuAberto(!menuAberto);
  };

  const fecharMenu = () => {
    setMenuAberto(false);
  };

  return (
    <nav
      className="navbar navbar-expand-lg navbar-light fixed-top py-2"
      style={{
        background: 'rgba(255,255,255,0.92)',
        backdropFilter: 'blur(6px)',
        boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
      }}
    >
      <div className="container d-flex justify-content-between align-items-center">

        {/* Logo */}
        <a className="navbar-brand d-flex align-items-center" href="#hero" onClick={fecharMenu}>
          <img
            src={logo}
            alt="Elaine Rampazzo – Terapia e Carreira"
            style={{
              height: '70px',
              objectFit: 'contain',
            }}
            className="me-2"
          />
        </a>

        {/* Botão mobile */}
        <button
          className="navbar-toggler"
          type="button"
          aria-label="Toggle navigation"
          onClick={toggleMenu}
        >
          <span className="navbar-toggler-icon" />
        </button>

        {/* Menu */}
        <div className={`navbar-collapse ${menuAberto ? 'show' : 'collapse'}`}>
          <ul className="navbar-nav align-items-lg-center ms-auto gap-lg-2">
            <li className="nav-item">
              <a className="nav-link" href="#hero" onClick={fecharMenu}>Início</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#para-quem" onClick={fecharMenu}>Atuação</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#sobre" onClick={fecharMenu}>Quem sou eu</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#servicos" onClick={fecharMenu}>Serviços</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#depoimentos" onClick={fecharMenu}>Depoimentos</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#faq" onClick={fecharMenu}>Dúvidas</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#contato" onClick={fecharMenu}>Contato</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/blog">Blog</a>
            </li>
          </ul>

          {/* Botão WhatsApp PADRONIZADO */}
          <a
            href="https://wa.me/5511962382055"
            className="btn-cta ms-lg-3 mt-3 mt-lg-0 d-inline-flex align-items-center gap-2 px-3 py-2"
            target="_blank"
            rel="noopener noreferrer"
            onClick={fecharMenu}
            style={{ fontSize: '0.95rem' }}
          >
            <i className="bi bi-whatsapp fs-5"></i>
            Agendar conversa
          </a>
        </div>
      </div>
    </nav>
  );
}